export default "__VITE_ASSET__DrmyHNDg__"